import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createStore } from "redux";
import allReducer from "./reducers";
import { Provider } from "react-redux";
import RateLayout from "./RateLayout";
import End from "./End";
import * as serviceWorker from "./serviceWorker";

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/:service_id/:icrm_id" element={<RateLayout />} />
      <Route path="/:uuid" element={<RateLayout />} />
      <Route path="/end" element={<End />} />
    </Routes>
  </Router>
);

const store = createStore(allReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
);

serviceWorker.unregister();
